import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, ButtonBase, Typography } from "@mui/material";
import { LocalOffer as OfferIcon } from "../icons";
import { Event as EventIcon } from "../icons";
import { DirectionsCar as CarIcon } from "../icons";
import { Home as PlaceIcon } from "../icons";
import { Storefront as StoreIcon } from "../icons";
import { DeliveryDining as FoodIcon } from "../icons";
import { Payment as PlanIcon } from "../icons";
import { ChevronRight as ChevronRightIcon } from "../icons";
import { brandColors } from "../theme";

const ICONS = { oferta: OfferIcon, evento: EventIcon, auto: CarIcon, propiedad: PlaceIcon, tienda: StoreIcon, local: FoodIcon, plan: PlanIcon };

// Publicaciones que encontró la IA (functions/aiAssistant.js), como tarjetas
// que se tocan enteras: ícono del tipo, título, detalle y flecha. Las usan el
// asistente flotante y el chat de soporte.
const AiLinkButtons = ({ links, onNavigate }) => {
  if (!links?.length) return null;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, mt: 1 }}>
      {links.map((link) => {
        const Icon = ICONS[link.type] || OfferIcon;
        return (
          <ButtonBase
            key={link.url}
            component={RouterLink}
            to={link.url}
            onClick={onNavigate}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              width: "100%",
              p: 1,
              textAlign: "left",
              borderRadius: 2,
              border: 1,
              borderColor: "divider",
              bgcolor: "background.paper",
              color: "text.primary",
              transition: "border-color 0.15s, background-color 0.15s",
              "&:hover": { borderColor: brandColors.accent, bgcolor: "action.hover" },
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                width: 34,
                height: 34,
                borderRadius: 1.5,
                display: "grid",
                placeItems: "center",
                bgcolor: "action.selected",
                color: brandColors.accent,
              }}
            >
              <Icon sx={{ fontSize: 18 }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 600,
                  lineHeight: 1.3,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {link.title}
              </Typography>
              {link.detail && (
                <Typography noWrap sx={{ fontSize: "0.72rem", color: "text.secondary", mt: 0.25 }}>
                  {link.detail}
                </Typography>
              )}
            </Box>
            <ChevronRightIcon sx={{ fontSize: 18, color: "text.secondary", flexShrink: 0 }} />
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default AiLinkButtons;
